import React from 'react';
import './SettingsMain.css'
import NavbarClass from '../NavbarClass';
import { Tab, Tabs, Nav } from 'react-bootstrap';

import Account from './Account';
import Plan from './Plan';
import WatchHistory from './WatchHistory';
import ContactUs from './ContactUs';
import { pageview } from '../../utils/googleAnalyticsUtils';

class SettingsMain extends React.Component{

    componentDidMount(){
        pageview('Settings');
    }

    state={selectedTab: 'Account'}

    handleSelectTab = async (selectedTab) => {
        await this.setState({selectedTab})
    }

    handleTabDisplay = () => {
        if (this.state.selectedTab==='Account') return <Account /> 
        else if (this.state.selectedTab==='Plan') return <Plan /> 
        else if (this.state.selectedTab==='WatchHistory') return <WatchHistory /> 
        else if (this.state.selectedTab==='ContactUs') return <ContactUs />
        else{
            return <Account />
        } 
    }

    render(){



        return(
            <div>
                <NavbarClass handleSignInOpen={this.props.handleSignInOpen} />
                <div className='container settings-container-c'>
                    <h2>Account Settings</h2>
                    <div className='settings-tabs-c'>
                        <Nav defaultActiveKey="Account" onSelect={this.handleSelectTab} className='flex-nowrap' bg='dark'>
                        <Nav.Item>
                            <Nav.Link eventKey="Account">Account</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="Plan">My Plan</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="WatchHistory">Watch History</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="ContactUs">Contact Us</Nav.Link>
                        </Nav.Item>
                        </Nav>
                    </div>
                    <hr style={{marginTop: '-4px'}} />
                    <div>
                       {this.handleTabDisplay()}
                    </div>
                </div>
            </div>
        )
    }
}

export default SettingsMain;